import React, { useState, useEffect } from "react";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import moment from "moment";

function ICDateInput(props) {
  const [selectedDate, handleDateChange] = useState(
    props.defaultDate ? new Date() : null
  );

  const handleChange = date => {
    handleDateChange(date);
    props.handleChange(date ? date.toISOString() : "");
  };

  useEffect(() => {
    if (
      props.defaultDate &&
      typeof props.defaultDate === "object" &&
      (props.defaultDate instanceof Date || props.defaultDate instanceof moment)
    ) {
      handleDateChange(props.defaultDate);
    } else if (props.defaultDate && moment(props.defaultDate, "DD-MM-YYYY", true).isValid()) {
      handleDateChange(moment(props.defaultDate, "DD-MM-YYYY").toISOString());
    }
  }, [props.defaultDate]);

  useEffect(() => {
    if (props.filterOn) {
      handleDateChange(props.filterOn);
    }
  }, [props.filterOn]);

  return (
    <div
      className={
        "w-100 ic-date-input " + (props.className ? props.className : "")
      }
    >
      <MuiPickersUtilsProvider
        utils={MomentUtils}
        className={props.className ? props.className : ""}
      >
        <KeyboardDatePicker
          autoOk
          variant="inline"
          id={props.id}
          name={props.name}
          label={props.label}
          format="DD/MM/YYYY"
          value={selectedDate ? selectedDate : null}
          InputAdornmentProps={{ position: "end" }}
          onChange={date => {
            handleChange(date);
          }}
          error={props.error}
          disabled={props.disabled === true ? true : false}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
}

export default ICDateInput;
